import axios from 'axios';
import { Toast } from 'vant';
import router from '@/router'
let domain = 'https://php.ycylwz.com/';

const objToUrl = obj => {
    let arr = [];
    for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
            arr.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
        }
    }
    return '?' + arr.join("&");
};

export const request = (method, _module, params = {}, headers = {}) => {
    //console.log(method,_module)
    //如果是GET方式 ， 则拼接URL参数；
    // if ('GET' === method) _module += objToUrl(params);
    _module = domain + _module;
    if ('GET' === method){
        return axios.get(_module, { params: params })
    } 
    if ('POSTA' === method){
        return axios.post(_module, params,{ headers: headers }, {
            transformRequest: data => {
                var str = [];
                for (var i in data) {
                    str.push(
                        encodeURIComponent(i) + "=" + encodeURIComponent(data[i])
						
                    );
                }
                return str.join("&");
            },			
        })
    }
    if ('POST' === method){
        return axios.post(_module, params, {
            transformRequest: data => {
                var str = [];
                for (var i in data) {
                    str.push(
                        encodeURIComponent(i) + "=" + encodeURIComponent(data[i])
                    );
                }
                return str.join("&");
            }
        })
    }
};

export const requestWx = (method, _module, params = {}, headers = {}) => {
    //console.log(method,_module)
    //如果是GET方式 ， 则拼接URL参数；
    // if ('GET' === method) _module += objToUrl(params);
    _module = wxmain + _module;
    if ('GET' === method){
        return axios.get(_module, { params: params })
    } 
	
    if ('POSTA' === method){
        return axios.post(_module, params,{ headers: headers }, {
            transformRequest: data => {
                var str = [];
                for (var i in data) {
                    str.push(
                        encodeURIComponent(i) + "=" + encodeURIComponent(data[i])
                    );
                }
                return str.join("&");
            }
        })
    }
    if ('POST' === method){
        return axios.post(_module, params, {
            transformRequest: data => {
                var str = [];
                for (var i in data) {
                    str.push(
                        encodeURIComponent(i) + "=" + encodeURIComponent(data[i])
                    );
                }
                return str.join("&");
            }
        })
    }
};

axios.interceptors.response.use(
    response => {
        let msg = response.data
        let responseURL=response.request.responseURL
        if(msg.status==2&&responseURL!='https://php.ycylwz.com/xcx/order/usercall'){
        	Toast(msg.msg);
          	setTimeout(() => {
                router.push("/user/login")
            }, 500);
        }else{
        	return response;
        }
    },
    error => {
        Message.error({
            message: error.message,
            duration: 5 * 1000,
            closable: true
        });
        return Promise.reject(error);
    }
 );


// WEBPACK FOOTER //
// ./src/api/request.js